import React from 'react';
import { AdminCrudShell } from '@/components/admin/AdminCrudShell';
import { Badge } from '@/components/ui/badge';
import { formatMoney } from '@/lib/api';

const STATUS_OPTS = [
  { value: '', label: 'Todos' },
  { value: 'pending', label: 'Pendiente' },
  { value: 'confirmed', label: 'Confirmada' },
  { value: 'failed', label: 'Fallida' },
  { value: 'cancelled', label: 'Cancelada' },
  { value: 'refunded', label: 'Reembolsada' },
  { value: 'expired', label: 'Expirada' },
];

const STATUS_COLOR = {
  confirmed: 'bg-[var(--ns-gold)]/20 text-[var(--ns-gold-700)]',
  pending: 'bg-amber-100 text-amber-800',
  failed: 'bg-[var(--ns-red)]/15 text-[var(--ns-red)]',
  cancelled: 'bg-[var(--ns-bg-2)] text-[var(--ns-text-muted)]',
  refunded: 'bg-blue-100 text-blue-800',
  expired: 'bg-[var(--ns-bg-2)] text-[var(--ns-text-muted)]',
};

// Formato compacto DD/MM/YYYY · HH:mm.
function fmtDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} · ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function UserCell({ row }) {
  const name = (row.user_name || '').trim();
  const email = row.user_email || '';
  if (!name && !email) return <span className="text-[var(--ns-text-muted)]">—</span>;
  if (!name) return <span className="text-xs" data-testid="pur-user-email">{email}</span>;
  return (
    <div className="flex flex-col leading-tight" data-testid="pur-user-cell">
      <span className="text-sm font-medium">{name}</span>
      <span className="text-xs text-[var(--ns-text-muted)]">{email}</span>
    </div>
  );
}

export default function AdminPurchases() {
  return (
    <AdminCrudShell
      title="Compras (pay-per-event)"
      subtitle="Listado de compras individuales por evento. Solo lectura."
      entity="purchases"
      testIdPrefix="admin-purchases"
      readOnly
      searchPlaceholder="Buscar usuario o evento…"
      filters={[{ name: 'status', label: 'Estado', options: STATUS_OPTS }]}
      columns={[
        { key: 'user', label: 'Usuario', render: (r) => <UserCell row={r} /> },
        { key: 'event', label: 'Evento', render: (r) => <span className="text-sm" data-testid="pur-event-title">{r.event_title || '—'}</span> },
        { key: 'amount_cents', label: 'Importe', render: (r) => <span className="whitespace-nowrap">{formatMoney(r.amount_cents, r.currency)}</span> },
        { key: 'provider', label: 'Proveedor', render: (r) => <Badge variant="secondary" className="uppercase tracking-wider text-[10px]">{r.provider}</Badge> },
        { key: 'status', label: 'Estado', render: (r) => <Badge className={`text-[10px] uppercase ${STATUS_COLOR[r.status] || ''}`}>{r.status}</Badge> },
        { key: 'created_at', label: 'Fecha', render: (r) => <span className="text-xs whitespace-nowrap" data-testid="pur-created">{fmtDateTime(r.created_at)}</span> },
      ]}
    />
  );
}
